<template>
    <div class="imgText">
        <div class="warp">
            <div v-if="infoData">
                <div class="account" v-if="infoData.introduce">
                    <div class="detail">
                        <img v-if="infoData.headImg" :src="infoData.headImg" align="left"/>
                        <h4>{{infoData.donerName}}</h4>
                        {{infoData.introduce}}
                    </div>
                </div>
            </div>
            <div class="tab-content">
                <div>
                    <dl v-for="(item,index) in currData" :key="index" :style="currData.length == 2 ? 'float:left':''">
                        <router-link tag="a" :to="{path:'pic',query:{id:item.id}}">
                            <dt>
                                <img :src="item.img" alt="">
                            </dt>
                        </router-link>
                        <dd>
                            <h3>{{item.title}}</h3>
                            <p>{{item.etitle}}</p>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
        <div class="goback" @click="goback"></div>
    </div>
</template>
<script type="text/javascript">
    export default {
        data(){
            return{
                currData:[],
                infoData:null,
                name:'',
                allData:[
                    {
                        name:'czc',
                        title:'常赞春先生捐赠',
                        donerName:'常赞春',
                        introduce:'字子襄，号髯翁、柞闬、迂生等，山西榆次人。光绪二十八年（1902）中举，1913年毕业于京师大学堂文科班。曾在山西大学、国民师范、进山中学等校任教，1923年任榆次县教育会长。毕生笃学经史、文学，又长于考据、金石、书画，尤擅篆隶，是清末民初山西卓有成就的书法和篆刻家。他是山西教育图书博物馆的积极筹备者之一，生前将所藏103件书画捐献给博物馆，其中不乏三晋名家和海内巨匠的作品。',
                        headImg:require('../static/imgs/donar/czc.jpg'),
                        proList:[{
                            id:'unit1_01',
                            img:require('../static/imgs/proList1/proList1_01.jpg'),
                            title:' 草书五言诗轴',
                            etitle:'赵鹤（清）',
                            size:'纵154厘米，横38厘米',
                            donor:'常赞春先生捐赠'
                        },{
                            id:'unit1_02',
                            img:require('../static/imgs/proList1/proList1_02.jpg'),
                            title:' 行书王昌龄《芙蓉楼送辛渐》诗轴',
                            etitle:'孙嘉淦（清）',
                            size:'纵175厘米，横77.5 厘米',
                            donor:'常赞春先生捐赠'
                        },{
                            id:'unit1_03',
                            img:require('../static/imgs/proList1/proList1_03.jpg'),
                            title:' 行书元好问《换得云台帖，喜而赋诗》诗轴',
                            etitle:'孙嘉淦（清）',
                            size:'纵94.5厘米，横54 厘米',
                            donor:'常赞春先生捐赠'
                        },{
                            id:'unit1_05',
                            img:require('../static/imgs/proList1/proList1_05.jpg'),
                            title:' 行书苏轼《跋石钟山记后》轴',
                            etitle:'祁世长（清）',
                            size:'纵118厘米，横49厘米',
                            donor:'常赞春先生捐赠'
                        },{
                            id:'unit1_06',
                            img:require('../static/imgs/proList1/proList1_06.jpg'),
                            title:' 行书录《纯正蒙求》句轴',
                            etitle:'祁世长（清）',
                            size:'纵117厘米，横48厘米',
                            donor:'常赞春先生捐赠'
                        },{
                            id:'unit1_07',
                            img:require('../static/imgs/proList1/proList1_07.jpg'),
                            title:' 《贾景伯嗜学图》轴',
                            etitle:'钱慧安（清）',
                            size:'纵109厘米，横49.5厘米',
                            donor:'常赞春先生捐赠'
                        },{
                            id:'unit1_08',
                            img:require('../static/imgs/proList1/proList1_08.jpg'),
                            title:' 仿华喦《忘忧多子图》轴',
                            etitle:'温忠翰（清）',
                            size:'纵76.5厘米，横38.2厘米',
                            donor:'常赞春先生捐赠'
                        },{
                            id:'unit1_09',
                            img:require('../static/imgs/proList1/proList1_09.jpg'),
                            title:' 山水轴',
                            etitle:'白恩佑（清）',
                            size:'纵47厘米，横31.5厘米',
                            donor:'常赞春先生捐赠'
                        }]
                    },
                    {
                        name:'mx',
                        title:'马鑫先生捐赠',
                        donerName:'马鑫',
                        introduce:'原名马膺桂，字馨山，号馥昂，山西介休人。幼承家学，嗜书如命。抗日战争时期被介休县抗日政府授予“著名爱国主义人士”称号。1946年接受陈庚将军赠剑，传为美谈。曾任山西省图书文物管理委员会副主任、山西省政治协商会议第一、二届委员。新中国成立初期，捐赠2800余册书籍和58件书画，书画作品以山西籍名家最具特色。',
                        headImg:'',
                        proList:[{
                            id:'unit2_01',
                            img:require('../static/imgs/proList2/proList2_01.jpg'),
                            title:' 行书七言联',
                            etitle:'张之万（清）',
                            size:'纵132厘米，横31.2厘米',
                            donor:'马鑫先生捐赠'
                        },{
                            id:'unit2_03',
                            img:require('../static/imgs/proList2/proList2_03.jpg'),
                            title:'行书七言诗轴',
                            etitle:'朱雯（清）',
                            size:'纵207厘米，横49.3厘米',
                            donor:'马鑫先生捐赠'
                        }]
                    },{
                        name:'yzz',
                        title:'尹正斋先生捐赠',
                        donerName:'尹正斋',
                        introduce:'1954、1956年，尹正斋先生先后两次捐赠共29件书画作品。包括黄慎、潘祖荫、寿耆、祁寯藻、杨笃、齐白石等名家。',
                        headImg:'',
                        proList:[{
                            id:'unit2_02',
                            img:require('../static/imgs/proList2/proList2_02.jpg'),
                            title:' 《紫藤蜜蜂图》轴',
                            etitle:'齐白石（现代）',
                            size:'纵97厘米，横39.5厘米',
                            donor:'尹正斋先生捐赠'
                        },{
                            id:'unit2_04',
                            img:require('../static/imgs/proList2/proList2_04.jpg'),
                            title:'《接蝠图》轴',
                            etitle:'黄慎（清）',
                            size:'纵192厘米，横109厘米',
                            donor:'1953年尹正斋先生捐赠'
                        }]
                    },{
                        name:'wys',
                        title:'吴元善先生捐赠',
                        donerName:'吴元善',
                        introduce:'原名吴乃慈，江苏宜兴人。1937年毕业于北平大学工学院机械系，1952年加入中国共产党，历任太原矿山机器厂技术设计科科长、总工程师。1954、1956、1976年，他三次捐赠珍贵书画共22件，其中傅山、高凤翰、顾见龙、改琦等人的书画作品均为不可多得的精品。',
                        headImg:'',
                        proList:[{
                            id:'unit2_05',
                            img:require('../static/imgs/proList2/proList2_05.jpg'),
                            title:'《云峰霖雨图》轴',
                            etitle:'高凤翰（清）',
                            size:'纵125厘米，横46厘米',
                            donor:'1954年吴元善先生捐赠'
                        },{
                            id:'unit2_06',
                            img:require('../static/imgs/proList2/proList2_06.jpg'),
                            title:'《子夜歌图》轴',
                            etitle:'改琦（清）',
                            size:'纵118厘米，横39.5厘米',
                            donor:'1954年吴元善先生捐赠'
                        }]
                    },{
                        name:'zhd',
                        title:'张会斗先生捐赠',
                        donerName:'张会斗',
                        introduce:'1956年，张会斗先生捐赠书画58件，包括程淓、赫奕、张士英、顾昶、奚冈、梁同书、张道渥、杨笃等人诸多珍品。赫弈《仿元人山水册》，纸本八开，浅绛山水，设色淡雅，深得元人笔法之意趣，于疏秀清润中蕴涵苍茫浑厚的韵味。册上有三晋名书家常旭春补题的楷书杜甫《秋兴八首》，堪称珠联璧合，实为难得。',
                        headImg:'',
                        proList:[{
                            id:'unit2_07',
                            img:require('../static/imgs/proList2/proList2_07.jpg'),
                            title:'仿元人山水册',
                            etitle:'赫奕（清）',
                            size:'纵47.5厘米，横33厘米',
                            donor:'1956年张会斗先生捐赠'
                        },{
                            id:'unit2_08',
                            img:require('../static/imgs/proList2/proList2_08.jpg'),
                            title:'《兰竹图》册',
                            etitle:'钱载（清）',
                            size:'纵23厘米，横26.6厘米',
                            donor:'1956年张会斗先生捐赠'
                        },{
                            id:'unit2_09',
                            img:require('../static/imgs/proList2/proList2_09.jpg'),
                            title:'《丛林流水图》轴',
                            etitle:'程淓（清）',
                            size:'纵133厘米，横71厘米',
                            donor:'1956年张会斗先生捐赠'
                        }]
                    },{
                        name:'jyx',
                        title:'贾玉祥先生捐赠',
                        donerName:'贾玉祥',
                        introduce:'',
                        headImg:'',
                        proList:[{
                            id:'unit2_10',
                            img:require('../static/imgs/proList2/proList2_10.jpg'),
                            title:'《雪景山水》横幅',
                            etitle:'戴克昌（清）',
                            size:'纵116厘米，横237厘米',
                            donor:'1958年贾玉祥先生捐赠'
                        }]
                    },
                    {
                        name:'lhn',
                        title:'刘画南先生捐赠',
                        donerName:'刘画南',
                        introduce:'',
                        headImg:'',
                        proList:[{
                            id:'unit2_11',
                            img:require('../static/imgs/proList2/proList2_11.jpg'),
                            title:'《麻姑献寿图》轴',
                            etitle:'焦秉贞（清）',
                            size:'纵148.5厘米，横76.3厘米',
                            donor:'1960年刘画南先生捐赠'
                        },{
                            id:'unit2_12',
                            img:require('../static/imgs/proList2/proList2_12.jpg'),
                            title:'《僧王像》轴',
                            etitle:'无款（清）',
                            size:'纵170厘米，横83厘米',
                            donor:'1960年刘画南先生捐赠'
                        }]
                    },{
                        name:'lj',
                        title:'梁寯先生捐赠',
                        donerName:'梁寯',
                        introduce:'字达之，号秀山，山西太原人，回族。出身于书香世家，自幼勤学不辍，泛览群书，尤其钟情传统书画的鉴赏和收藏，致力于山西书画名家的研究，是国内外公认的傅山研究专家，今存山西博物院的傅山真迹，多出自其鉴定。1951年开始从事文博工作，1980-1986年，出任山西省博物馆副馆长，后任名誉馆长、中国博物馆学会理事等职。1955、1956年先后捐赠明清书画35件，其中倪元璐草书七言诗轴、王岱《岁寒三友图》、李文烛《黄白镜》册等均为极具价值的书画珍品。',
                        headImg:require('../static/imgs/donar/lj.jpg'),
                        proList:[{
                            id:'unit2_13',
                            img:require('../static/imgs/proList2/proList2_13.jpg'),
                            title:'《岁寒三友图》轴',
                            etitle:'王岱（清）',
                            size:'纵112厘米，横38厘米',
                            donor:'1960年梁寯先生捐赠'
                        }]
                    },{
                        name:'dsp',
                        title:'董寿平先生捐赠',
                        donerName:'董寿平',
                        introduce:'原名董揆，字谐柏，后改名寿平，山西洪洞人，当代著名画家、美术理论家、鉴赏家。曾任全国政协委员、中国书法家协会理事、北京中国画研究会名誉会长等。出身诗书世家，自幼喜爱书画，初画花卉，后研山水，尤喜写墨竹、墨梅及黄山风景。20世纪五六十年代，先后两次捐赠祖传古代书画13幅，其中王翚、傅山、秦炳文等人的作品均为稀世翰墨。',
                        headImg:require('../static/imgs/donar/dsp.jpg'),
                        proList:[{
                            id:'unit2_14',
                            img:require('../static/imgs/proList2/proList2_14.jpg'),
                            title:'《太华冲雪图》卷',
                            etitle:'秦炳文（清）',
                            size:'纵33厘米，横69厘米',
                            donor:'1961年董寿平先生捐赠'
                        },{
                            id:'unit2_15',
                            img:require('../static/imgs/proList2/proList2_15.jpg'),
                            title:'《汉书下酒图》卷',
                            etitle:'董文涣（清）',
                            size:'纵28.7厘米，横57.5厘米',
                            donor:'1961年董寿平先生捐赠'
                        },{
                            id:'unit2_16',
                            img:require('../static/imgs/proList2/proList2_16.jpg'),
                            title:'《老屋校书图》卷',
                            etitle:'温忠翰（清）',
                            size:'纵32厘米，横129厘米',
                            donor:'1961年董寿平先生捐赠'
                        },]
                    },{
                        name:'cfx',
                        title:'常风玄先生捐赠',
                        donerName:'常风玄',
                        introduce:'山西太原人，常赞春之子。早年毕业于中央民族学院藏语专业，后任中国社科院民族所研究员。毕生致力于藏学研究，是国内藏学界的代表人物，曾参加《辞海》、《中国大百科全书·民族卷》、《中国地名大辞典》等书中有关藏族史部分的编撰。1961年，他将常氏家族珍藏的28幅书画捐献给博物馆，其中不乏珍品，尤以傅山的《雨中花鸭图》最为难得。该图不仅为后人研究傅山画艺提供了资料，其上的民国三晋学者题跋也是难能可贵的文化遗产。',
                        headImg:require('../static/imgs/donar/cfx.jpg'),
                        proList:[{
                            id:'unit2_17',
                            img:require('../static/imgs/proList2/proList2_17.jpg'),
                            title:'《松石图》轴',
                            etitle:'汪洛年（民国）',
                            size:'纵76.2厘米，横29.5厘米',
                            donor:'1961年常风玄先生捐赠'
                        }]
                    },{
                        name:'fzy',
                        title:'傅作义先生捐赠',
                        donerName:'傅作义',
                        introduce:'字宜生，山西临猗人。抗日名将，北平和平解放功臣。1949年当选为第一届全国政协委员、中央人民政府委员，历任政协第二、三届全国委员会常务委员，政协第四届全国委员会副主席，第一、二、三届全国人大代表、国防委员会副主席，水利部部长等职。1963年捐献傅山草书《临王羲之〈明府帖〉》，使傅山先生的作品得以回归故乡，为山西的文化建设又添上一笔财富。',
                        headImg:require('../static/imgs/donar/fzy.jpg'),
                        proList:[{
                            id:'unit2_18',
                            img:require('../static/imgs/proList2/proList2_18.jpg'),
                            title:'临王羲之《明府帖》轴',
                            etitle:'傅山（清）',
                            size:'纵76.5厘米，横38.2厘米',
                            donor:'1963年傅作义先生捐赠'
                        }]
                    },{
                        name:'ljy',
                        title:'罗静宜女士捐赠',
                        donerName:'冀朝鼎，罗静宜',
                        introduce:'冀朝鼎（1903-1963），号筱泉，笔名动平，山西汾阳人，我国著名经济学家、外交家，曾任中国国际贸易促进会副主席兼中国人民银行副董事长、中国拉丁美洲友好协会副会长等职。罗静宜（1905-1998），冀朝鼎夫人，原名罗素抒，上海人，曾担任中央外贸局联络处处长、中国国际贸易促进会业务部部长、中央调查部副局长等职。冀朝鼎先生去世后，遵照他的遗愿，罗静宜女士于1964年捐赠家藏明清书画珍品47幅，其中为数众多的傅山翰墨是傅山藏品中的佳作。',
                        headImg:'',
                        proList:[{
                            id:'unit2_19',
                            img:require('../static/imgs/proList2/proList2_19.jpg'),
                            title:'行书五绝诗轴',
                            etitle:'陈继儒（明）',
                            size:'纵78.5厘米，横18厘米',
                            donor:'1964年罗静宜女士捐赠'
                        },{
                            id:'unit2_20',
                            img:require('../static/imgs/proList2/proList2_20.jpg'),
                            title:'草书《游房山山寺》诗轴',
                            etitle:'王铎（清）',
                            size:'纵236厘米，横53厘米',
                            donor:'1964年罗静宜女士捐赠'
                        },{
                            id:'unit2_21',
                            img:require('../static/imgs/proList2/proList2_21.jpg'),
                            title:'草书杜甫《夔州歌》之四诗轴',
                            etitle:'傅山（清）',
                            size:'纵185厘米，横56厘米',
                            donor:'1964年罗静宜女士捐赠'
                        },{
                            id:'unit2_22',
                            img:require('../static/imgs/proList2/proList2_22.jpg'),
                            title:' 行书王昌龄《芙蓉楼送辛渐》诗轴',
                            etitle:'孙嘉淦（清）',
                            size:'纵175厘米，横77.5 厘米',
                            donor:'马鑫先生捐赠'
                        },{
                            id:'unit2_23',
                            img:require('../static/imgs/proList2/proList2_23.jpg'),
                            title:'篆书《孟子·滕文公下》句轴',
                            etitle:'王澍（清）',
                            size:'纵109厘米，横58厘米',
                            donor:'1964年罗静宜女士捐赠'
                        },{
                            id:'unit2_24',
                            img:require('../static/imgs/proList2/proList2_24.jpg'),
                            title:'行书录《内史与谢尚书书》轴',
                            etitle:'包世臣（清）',
                            size:'纵128厘米，横55.5厘米',
                            donor:'1964年罗静宜女士捐赠'
                        },{
                            id:'unit2_25',
                            img:require('../static/imgs/proList2/proList2_25.jpg'),
                            title:'《山水图》轴',
                            etitle:'严载（清）',
                            size:'纵96厘米，横39.5厘米',
                            donor:'1964年罗静宜女士捐赠'
                        }]
                    },{
                        name:'wsq',
                        title:'王世庆先生捐献',
                        donerName:'王世庆',
                        introduce:'1975年，山西临汾铁路局王世庆先生捐赠数十件家藏书画作品。包括赵鹤、祁寯藻、吴雯、赵昌燮、冯志沂、宋伯鲁等名家，颇为可观。',
                        headImg:'',
                        proList:[{
                            id:'unit2_26',
                            img:require('../static/imgs/proList2/proList2_26.jpg'),
                            title:'行书五言诗轴',
                            etitle:'吴雯（清）',
                            size:'纵79厘米，横28厘米',
                            donor:'1975年王世庆先生捐献'
                        },{
                            id:'unit2_27',
                            img:require('../static/imgs/proList2/proList2_27.jpg'),
                            title:'行书诗册',
                            etitle:'祁寯藻（清）',
                            size:'纵26厘米，横21.5厘米',
                            donor:'1975年王世庆先生捐献'
                        }]
                    },{
                        name:'hbj',
                        title:'郝秉寯先生捐赠',
                        donerName:'郝秉寯',
                        introduce:'',
                        headImg:'',
                        proList:[{
                            id:'unit2_28',
                            img:require('../static/imgs/proList2/proList2_28.jpg'),
                            title:'扇画合轴',
                            etitle:'宋葆淳等（清）',
                            size:'纵52厘米，横158厘米',
                            donor:'郝秉寯先生捐赠'
                        }]
                    },{
                        name:'zsq',
                        title:'朱绍钦先生捐赠',
                        donerName:'朱绍钦',
                        introduce:'',
                        headImg:'',
                        proList:[{
                            id:'unit2_29',
                            img:require('../static/imgs/proList2/proList2_29.jpg'),
                            title:'《芙蓉水鸟图》轴',
                            etitle:'张敔（清）',
                            size:'纵179.5厘米，横45厘米',
                            donor:'朱绍钦先生捐赠'
                        }]
                    },{
                        name:'yjc',
                        title:'游介忱先生捐赠',
                        donerName:'游介忱',
                        introduce:'',
                        headImg:'',
                        proList:[{
                            id:'unit2_30',
                            img:require('../static/imgs/proList2/proList2_30.jpg'),
                            title:'《杨二酉父母之诰命》卷',
                            etitle:'杨二酉（清）',
                            size:'纵30厘米，横181厘米',
                            donor:'游介忱先生捐赠'
                        }]
                    },{
                        name:'qzz',
                        title:'钱自在先生捐赠',
                        donerName:'钱自在',
                        introduce:'字容之，山西文水人，著名书画鉴定家、收藏家。14岁即赴北京谋生，向国画大师徐宗浩（雪石）学习画艺，造诣颇深，又兼喜爱文物，精于鉴赏，与张伯驹等大师均有交往。1986年捐赠书画、瓷器、印章等文物110余件，其中元代髮僧《祇园大会图》卷、顾安《风竹图》、元代《起蛟图》和明代《白描罗汉渡海图》卷等均为难得的稀世珍品。钱自在所捐文物数量大、质量高，极大地提高了馆藏文物的质量。',
                        headImg:require('../static/imgs/donar/qzz.jpg'),
                        proList:[{
                            id:'unit3_01',
                            img:require('../static/imgs/proList3/proList3_01.jpg'),
                            title:'《风竹图》轴',
                            etitle:'顾安（元）',
                            size:'纵106厘米，横33.5厘米',
                            donor:'1986年钱自在先生捐赠'
                        },{
                            id:'unit3_02',
                            img:require('../static/imgs/proList3/proList3_02.jpg'),
                            title:'《起蛟图》轴',
                            etitle:'无款（元）',
                            size:'纵95.5厘米，横40.5厘米',
                            donor:'1986年钱自在先生捐赠'
                        },{
                            id:'unit3_03',
                            img:require('../static/imgs/proList3/proList3_03.jpg'),
                            title:'《祇园大会图》卷',
                            etitle:'髪僧（元）',
                            size:'纵37.2厘米，横1889厘米',
                            donor:'1986年钱自在先生捐献'
                        },{
                            id:'unit3_04',
                            img:require('../static/imgs/proList3/proList3_04.jpg'),
                            title:'《兰亭修禊图》轴',
                            etitle:'无款（明）',
                            size:'纵162.5厘米，横88厘米',
                            donor:'1986年钱自在先生捐赠'
                        },{
                            id:'unit3_05',
                            img:require('../static/imgs/proList3/proList3_05.jpg'),
                            title:'白描《罗汉渡海图》卷',
                            etitle:'无款（明）',
                            size:'纵27厘米，横975厘米',
                            donor:'1986年钱自在先生捐赠'
                        },{
                            id:'unit3_06',
                            img:require('../static/imgs/proList3/proList3_06.jpg'),
                            title:'行书七绝诗轴',
                            etitle:'于成龙（清）',
                            size:'纵165厘米，横43厘米',
                            donor:'1986年钱自在先生捐赠'
                        },{
                            id:'unit3_07',
                            img:require('../static/imgs/proList3/proList3_07.jpg'),
                            title:'楷书录王应麟《困学纪闻》句轴',
                            etitle:'钱沣（清）',
                            size:'纵57厘米，横22厘米',
                            donor:'1986年钱自在先生捐赠'
                        },{
                            id:'unit3_08',
                            img:require('../static/imgs/proList3/proList3_08.jpg'),
                            title:'《盆梅图》轴',
                            etitle:'伊秉绶（清）',
                            size:'纵53厘米，横32厘米',
                            donor:'1986年钱自在先生捐赠'
                        }]
                    },{
                        name:'zzk',
                        title:'赵正楷先生捐赠',
                        donerName:'赵正楷',
                        introduce:'字法真，山西原平人。1925年毕业于山西大学法科。先后在民国山西省政府村政处、山西公报馆、山西书局、山西公营事业董事会等任职，后定居台湾。他一生雅好傅山书艺，曾先后将多件傅山墨迹、手稿影印出版。1993年，赵正楷亲属遵照其遗愿，将珍藏的傅山楷书《阿难吟》册与草书《千字文》册捐赠给博物馆。',
                        headImg:require('../static/imgs/donar/zzk.png'),
                        proList:[{
                            id:'unit3_09',
                            img:require('../static/imgs/proList3/proList3_09.jpg'),
                            title:'草书《千字文》册',
                            etitle:'傅山（清）',
                            size:'纵24.7厘米，横25.5厘米',
                            donor:'1993年赵正楷先生捐赠'
                        },{
                            id:'unit3_10',
                            img:require('../static/imgs/proList3/proList3_10.jpg'),
                            title:'楷书《阿难吟》册',
                            etitle:'傅山（清）',
                            size:'纵22.5厘米，横12.5厘米',
                            donor:'1993年赵正楷先生捐赠'
                        }]
                    }
                ]
            }
        },
        mounted(){
            this.name = this.$router.history.current.query.name;
            var dataJson = this.allData;
            for(var i=0;i<dataJson.length;i++){
                if(dataJson[i].name == this.name){
                    this.infoData = dataJson[i];
                    this.currData = dataJson[i].proList
                }
            }
        },
        methods:{
            goback(){
                if(window.history.length == 1){
                    this.$router.push({path:"/"})
                }else{
                    this.$router.go(-1)
                }
            }
        }
    }
</script>
<style scoped>
    .imgText{
        min-height:100%;
        background-color: #f1f1f1;
    }
    .goback{
        width: 1.63rem;
        height: 1.63rem;
        background:url(../static/imgs/goback.png);
        background-size: 100% 100%;
        position: fixed;
        right: .17rem;
        top:50%;
        margin-top: -.815rem;
    }
    .warp{
        margin: 0 auto;
        padding-top: .2rem;
    }
    .account{
        background: url('../static/imgs/account2.png') no-repeat center / contain;
        width:7.02rem;
        height:5.21rem;
        margin:0 auto .4rem;
        color:#555;
        overflow: hidden;
    }
    .detail{
        padding:.23rem .3rem 0 .41rem;
        font-size: .28rem;
        line-height: .40rem;
        letter-spacing: .01rem;
    }
    .detail h4{font-weight:bold;}
    .account img{width:1.6rem;margin:0 .29rem 0 0;}
    .title{
        width: 100%;
        text-align: left;
        font-size:20px;
        position: relative;
        margin-bottom: .8rem;
    }
    .title span{
        text-indent:0.14rem;
        letter-spacing: 3px;
        display: inline-block;
        z-index: 3;
        position: absolute;
    }
    .title em{
        display: inline-block;
        width: 0.85rem;
        height:9px;
        background: #e6bb70;
        left: 0.20rem;
        position: absolute;
        z-index: 1;
        top:10px;
    }
    .cont{
        width: 90%;
        margin: 0 auto;
    }
    .cont p{
        font-size: 16px;
        color:#666666;
        line-height: 30px;
        text-align: justify;
        margin-bottom: .10rem;
    }
    .cont dl{
        width: 100%;
        margin-bottom:.10rem;
    }
    .cont dl dt img{
        width: 100%;
    }
    .cont dl dd{
        font-size:14px;
        color:#adadad;
        margin-top: 0.15rem;
        line-height: 20px;
    }
    .butn{
        /*background:url(../static/bj1.png);*/
        height:.4rem;
        background-size: 100%;
        margin-top:.25rem;
        position: relative;
    }
    .btnC{
        width: 0.45rem;
        height: 0.23rem;
        border-radius: 50px;
        background:#fff;
        box-shadow: 0px 1px 15px #ededed;
        text-align: center;
        line-height: 0.23rem;
        margin: 0 auto;
        margin-top: -0.11rem;
        position: absolute;
        left: 50%;
        margin-left: -0.25rem;
        color:#e6bb70;
    }
    .activeClass{
        height: 2rem;
        overflow:hidden;
    }
    .hideClass{
        height: auto;
    }
    .tab-tilte{
        width:1500px;
    }
    .tab-tilte li{
        float: left;
        width:1rem;
        padding: 10px 0;
        text-align: center;
        cursor: pointer;
        color:#cdcdcd;
        font-size: 18px;
        font-weight: bolder;
    }
    /* 点击对应的标题添加对应的背景颜色 */
    .tab-tilte .active{
        color: #e6bb70;
    }

    .tab-content div{
        /*padding-right: .4rem;*/
        margin-top:.2rem;
        column-count:2;
        padding-left: .03rem;
    }
    .tab-content div dl{
        break-inside:avoid;
        margin-left: .2rem;
        width:3.4rem;
        background: #fff;
        display: inline-block;
        margin-bottom: .2rem;
        border-radius: .1rem;
    }
    .tab-content div dl dt{
        justify-content: center;
        align-items: center;
    }
    .tab-content div dl dt img{
        width:100%;
        border-radius: 4px 4px 0 0;
    }
    .tab-content div dl dd{
        padding-bottom: .46rem;
        background:#fff;
    }
    .tab-content h3{padding:.29rem .21rem .2rem;font-size: .28rem;line-height: normal;font-weight: bold;color:#333;}
    .tab-content p{padding:0 .21rem;color:#666;font-size: .24rem;}

</style>